// import http from './httpsemtoken'
import qs from 'querystring'
// import axios from 'axios'
let url = 'security/token'
// require('@/service/service_autoatendimento/httpsemtoken')
// const urlAdaptor = localStorage.getItem('APIAdaptor')
// var http = axios.create({
//   baseURL:urlAdaptor
// })
// http.defaults.headers.modulo = 4
import http from './httpsemtoken'
export function postLogin (payload) {
   let data = qs.stringify({
     grant_type: payload.grant_type,
     username: payload.UserName,
     password: payload.password
   })
   return http.post(url, data)
 }

 export function postRenew (payload) {
   let data = qs.stringify({
     grant_type: payload.grant_type,
     username: payload.username,
     refresh_token: payload.refresh_token
   })

   return http.post(url, data)
 }